/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_YesInputs */

const en_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_ccsl_export_yes = /** @type {(inputs: Ccsl_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Ccsl_Export_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_yes = /** @type {((inputs?: Ccsl_Export_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_yes(inputs)
	if (locale === "de") return de_ccsl_export_yes(inputs)
	if (locale === "it") return it_ccsl_export_yes(inputs)
	if (locale === "ru") return ru_ccsl_export_yes(inputs)
	if (locale === "es") return es_ccsl_export_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_yes(inputs)
	if (locale === "ja") return ja_ccsl_export_yes(inputs)
	if (locale === "hi") return hi_ccsl_export_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_yes(inputs)
	return en_ccsl_export_yes(inputs)
});